import React, {createContext, useContext} from "react"
import {useLocation, Location} from "react-router-dom"
import History, {PBHistory} from "@irati/utils/history"

interface HistoryContextValue {
  history: PBHistory
  location: Location
}

const HistoryContext = createContext<HistoryContextValue | null>(null)

interface HistoryProviderProps {
  children: React.ReactNode
}

export const HistoryProvider: React.FC<HistoryProviderProps> = ({children}) => {
  const location = useLocation()
  const value = React.useMemo(() => ({history: History, location}), [location])
  return <HistoryContext.Provider value={value}>{children}</HistoryContext.Provider>
}

export const useHistory = (): HistoryContextValue => {
  const context = useContext(HistoryContext)
  if (!context) {
    throw new Error("useHistory must be used within a HistoryProvider")
  }
  return context
}
